import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "conversation",
  "use": "conversation-usage",
  "viewBox": "0 0 20 17",
  "content": "<symbol viewBox=\"0 0 20 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"conversation\">\n<path d=\"M13 8V2C13 0.90625 12.0938 0 11 0H2C0.875 0 0 0.90625 0 2V8C0 9.125 0.875 10 2 10L3 10.0312V11.625C3 11.875 3.15625 12 3.375 12C3.4375 12 3.5 12 3.59375 11.9375L7 10H11C12.0938 10 13 9.125 13 8ZM6.59375 8.5L4.5 9.71875V8.5H2C1.71875 8.5 1.5 8.28125 1.5 8V2C1.5 1.75 1.71875 1.5 2 1.5H11C11.25 1.5 11.5 1.75 11.5 2V8C11.5 8.28125 11.25 8.5 11 8.5H6.59375ZM18 4H14V8C14 9.65625 12.625 11 11 11H8V12C8 13.125 8.875 14 9.96875 14H13.875L16.4688 15.9375C16.6875 16.0938 17 15.9688 17 15.7188V14H18C19.0938 14 20 13.125 20 12.0312V6C20 4.90625 19.0938 4 18 4Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/conversation.svg
// module id = G3Ce
// module chunks = 13